import { useBlocker } from "react-router-dom"
import AreYouSureModal from "../../routes/components/AreYouSureModal"

function Prompt(props) {
	const { when, message } = props

	const blocker = useBlocker(when)

	return (
		<AreYouSureModal
			id="blocker_AreYouSure"
			isOpen={blocker.state === "blocked"}
			message={<span>{message()}</span>}
			action={blocker.proceed}
			cancel={blocker.reset}
		/>
	)
}

export default Prompt
